import { render, staticRenderFns } from "./BigBannerCatalog.vue?vue&type=template&id=c41e6f22"
import script from "./BigBannerCatalog.vue?vue&type=script&lang=js"
export * from "./BigBannerCatalog.vue?vue&type=script&lang=js"
import style0 from "./BigBannerCatalog.vue?vue&type=style&index=0&id=c41e6f22&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports